import Vue from 'vue';
import VueRouter from 'vue-router';
// 引入 store
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/:id',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/index.vue'),
  },
  {
    path: '*',
    name: 'error-page',
    component: () => import(/* webpackChunkName: "error-page" */ '@/views/error-page/index.vue'),
  },
  {
    path: '/beiligong/:id',
    name: 'beiligong',
    component: () => import(/* webpackChunkName: "beiligong" */ '@/views/beiligong/index.vue'),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  store.commit('setId', to.params.id ? to.params.id : 0);
  console.log(to.params.id, '');
  return next();
});

export default router;
